






























































import Vue from "vue";
import Component from "vue-class-component";
import {Client, WhitelistClient} from "../model/interface/client.interface";
import {ClientService} from "../services/client.service";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";
import {ProjectMetaData} from "../model/interface/project.interface";
import {ProjectService} from "../services/project.service";
import ProjectCardComponent from "./project-card.vue";


@Component({
  components: {
    ProjectCardComponent
  }
})
export default class AdminComponent extends Vue {
  private selectedClient: Client = null;
  private clients: Client[] = [];
  private loading: boolean = false;
  private projects: ProjectMetaData[] = [];

  async mounted() {
    this.loading = true;
    try {
       let clientsList: Client[] | false = await ClientService.loadAllUsers();
      if(!clientsList) {
        MessageBus.$emit(AlertType[AlertType.error], 'Error during clientlist fetch!');
        return;
      }
      this.clients = clientsList;

      this.projects = await ProjectService.getAllProjectMetaData();
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during client/project list fetch! ' + e);
    } finally {
      this.loading = false;
    }
  }

  private async deleteUser() {
    this.loading = true;
    try {
      const result: string = await ClientService.deleteUser(this.selectedClient.username);
      MessageBus.$emit(AlertType[AlertType.success], `Client ${result} successfully removed!`);
      this.clients.splice(this.clients.indexOf(this.selectedClient),1);
      this.selectedClient = null;
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during client deletion! ' + e);
    } finally {
      this.loading = false;
    }
  }

  private onSelectClient(client: Client) {
    this.selectedClient = client;
  }
}

